import { render, staticRenderFns } from "./PackingHistoryDrawer.vue?vue&type=template&id=6a2d91fc&scoped=true&"
import script from "./PackingHistoryDrawer.vue?vue&type=script&lang=js&"
export * from "./PackingHistoryDrawer.vue?vue&type=script&lang=js&"
import style0 from "./PackingHistoryDrawer.vue?vue&type=style&index=0&id=6a2d91fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2d91fc",
  null
  
)

export default component.exports